import { Spin } from 'antd';

function Spinner() {
  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
    }}>
      <Spin size='large' />
    </div>
  )
}

export default Spinner